<template>
    <div class="search_list">
        <div class="top">
            <ul class="top-list">
                <li class="group" @click="showPopUp('left')">筛选</li>
                <li class="sort" @click="showPopUp('right')">排序</li>
            </ul>
        </div>
        <div class="count">共检索到{{ count }}条数据</div>
        <ul class="search_ul">
            <li class="search_list_single" v-for="(item, i) in datalist" :key="item.id" @click="getDetail(item.url)">
                <h2>{{ i + 1 }},{{ item.ti }}</h2>
                <p><span v-if="item.au">作者：</span>{{ item.au }}</p>
                <p><span v-if="item.ab">摘要：</span>{{ item.ab }}</p>
                <p><span v-if="item.so">来源：</span>{{ item.so }}</p>
            </li>
        </ul>
        <!--左侧过滤菜单-->
        <md-popup v-model="isPopupShow.left" position="left">
            <div class="md-example-popup md-example-popup-left dempo_box">
                <div class="dempo">
                    <div class="left-title">筛选</div>
                    <div class="md-example-child md-example-child-check md-example-child-check-4">
                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title" @click="PublicationDateImgShow = !PublicationDateImgShow">
                                <p class="saixuan_tit">Publication Date</p>
                                <img :src="PublicationDateImgShow ? up : down" alt="" class="up_down" />
                            </div>
                            <div v-show="PublicationDateImgShow" class="checkbox_list_single">
                                <div class="checkbox_list" v-for="(item, k) in PublicationDate" :key="item.name">
                                    <input
                                        type="radio"
                                        class="check_box tui-checkbox dan"
                                        name="screen"
                                        :id="'PublicationDate' + k"
                                        :value="item.key"
                                        v-model="PublicationDateSingle"
                                    />
                                    <label :for="'PublicationDate' + k" class="checkbox_title" @click="facetSearch(item.url)">{{ item.name }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title" @click="PublishedInImgShow = !PublishedInImgShow">
                                <p class="saixuan_tit">Published In</p>
                                <img :src="PublishedInImgShow ? up : down" alt="" class="up_down" />
                            </div>
                            <div v-show="PublishedInImgShow" class="checkbox_list_single">
                                <div class="checkbox_list" v-for="(item, k) in PublishedIn" :key="item.name">
                                    <input
                                        type="radio"
                                        class="check_box tui-checkbox dan"
                                        name="screen"
                                        :id="'PublishedIn' + k"
                                        :value="item.key"
                                        v-model="PublishedInSingle"
                                    />
                                    <label :for="'PublishedIn' + k" class="checkbox_title" @click="facetSearch(item.url)">{{ item.name }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title" @click="SubjectsImgShow = !SubjectsImgShow">
                                <p class="saixuan_tit">Subjects</p>
                                <img :src="SubjectsImgShow ? up : down" alt="" class="up_down" />
                            </div>
                            <div v-show="SubjectsImgShow" class="checkbox_list_single">
                                <div class="checkbox_list" v-for="(item, k) in Subjects" :key="item.name">
                                    <input
                                        type="radio"
                                        class="check_box tui-checkbox dan"
                                        name="screen"
                                        :id="'Subjects' + k"
                                        :value="item.key"
                                        v-model="SubjectsSingle"
                                    />
                                    <label :for="'Subjects' + k" class="checkbox_title" @click="facetSearch(item.url)">{{ item.name }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="btn_search_face">
                            <button class="btn" @click="clearSearch">清空</button>
                        </div>
                    </div>
                </div>
            </div>
        </md-popup>
        <!--右侧排序菜单-->
        <md-popup v-model="isPopupShow.right" position="right">
            <div class="md-example-popup md-example-popup-left dempo_box">
                <div class="dempo">
                    <div class="left-title">排序</div>
                    <div class="md-example-child md-example-child-check md-example-child-check-4">
                        <div class="md-example-child md-example-child-check md-example-child-check-1 selectDemo">
                            <div class="select-title">排序</div>
                            <div class="checkbox_list">
                                <input
                                    type="radio"
                                    class="check_box tui-checkbox dan"
                                    name="CiteScore"
                                    id="CiteScoreA"
                                    value="relevancy"
                                    v-model="sortBy"
                                />
                                <label for="CiteScoreA" @click="facetSortBy('relevancy')" class="checkbox_title">相关性</label>
                            </div>
                            <div class="checkbox_list">
                                <input
                                    type="radio"
                                    class="check_box tui-checkbox dan"
                                    name="CiteScore"
                                    id="CiteScoreB"
                                    value="last"
                                    v-model="sortBy"
                                />
                                <label for="CiteScoreB" @click="facetSortBy('last')" class="checkbox_title">最近年</label>
                            </div>
                        </div>
                        <div class="btn_search_face_right">
                            <button class="btn" @click="clearSearch">清空</button>
                        </div>
                    </div>
                </div>
            </div>
        </md-popup>
    </div>
</template>

<script>
import { Toast } from "vant";
import upImg from "../../assets/img/up.png";
import downImg from "../../assets/img/down.png";

export default {
    name: "sciencelist",
    data() {
        return {
            datalist: [],
            page: 1,
            facetPage: 1, //分面检索分页接口
            count: 0,
            PublicationDate: [],
            PublishedIn: [],
            Subjects: [],
            PublicationDateSingle: "",
            PublishedInSingle: "",
            SubjectsSingle: "",
            /*左右侧弹出*/
            isPopupShow: {
                left: false,
                right: false
            },
            sortBy: "relevancy",
            screen: "",
            url: "",
            up: upImg,
            down: downImg,
            //图片的切换
            PublicationDateImgShow: false,
            PublishedInImgShow: false,
            SubjectsImgShow: false,
            facet: "",
            facetUrl: ""
        };
    },
    mounted() {
        this.url = this.$route.query.url;
        this.wileySearch();
        let that = this;
        window.onscroll = function() {
            //变量scrollTop是滚动条滚动时，距离顶部的距离
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            //滚动条到底部的条件
            if (scrollTop !== 0 && that.$route.name === "wileylist") {
                if (Math.ceil(scrollTop + windowHeight) == scrollHeight || Math.floor(scrollTop + windowHeight) == scrollHeight) {
                    //写后台加载数据的函数
                    that.wileySearchPage();
                }
            }
        };
        this.$store.dispatch("actionsHead", { type: true, title: "WILEY", iconType: true });
    },
    beforeRouteLeave(to, from, next) {
        // 进入C时B正常缓存 当进入的不是C时 this.$destroy()销毁后
        if (to.name === "springerdetail") {
            if (!from.meta.isKeepAlive) {
                from.meta.isKeepAlive = true; // 当我们进入到C时开启B的缓存
            }
            next();
        } else {
            from.meta.isKeepAlive = false;
            this.$vnode.parent.componentInstance.cache = {};
            this.$vnode.parent.componentInstance.keys = [];
            next(); // 当我们前进的不是C时我们让B页面刷新
        }
    },
    methods: {
        wileySearch() {
            let url = "";
            url = this.url + "&page=1&sortBy=" + this.sortBy;
            this.$get("/wiley/search?" + url).then((res) => {
                if (res.code === 0) {
                    this.datalist = res.data.list;
                    this.count = res.data.total;
                    this.PublicationDate = res.data.filters["Publication Date"];
                    this.PublishedIn = res.data.filters["Published in"];
                    this.Subjects = res.data.filters["Subjects"];
                } else {
                    Toast(res.msg);
                }
            });
        },
        //分页
        wileySearchPage() {
            let url = "";
            let reqUrl = "";
            if (this.facet === "") {
                //正常检索分页
                this.page++;
                url = this.$route.query.url;
                url += "&page=" + this.page + "&sortBy=" + this.sortBy;
                reqUrl = "/wiley/search?";
                this.facetPage = 1;
            } else if (this.facet === "facet") {
                //分面检索分页
                this.facetPage++;
                this.page = 1;
                url = encodeURIComponent(decodeURIComponent(this.facetUrl) + "&startPage=" + this.facetPage + "&sortBy=" + this.sortBy);
                reqUrl = "/wiley/refine?url=";
            }
            this.$get("https://res.yuntsg.com" + reqUrl + url).then((res) => {
                if (res.code === 0) {
                    this.datalist = this.datalist.concat(res.data.list);
                    this.count = res.data.total;
                    this.PublicationDate = res.data.filters["Publication Date"];
                    this.PublishedIn = res.data.filters["Published in"];
                    this.Subjects = res.data.filters["Subjects"];
                } else {
                    Toast(res.msg);
                }
            });
        },
        //清空检索条件
        clearSearch() {
            this.PublicationDateSingle = "";
            this.PublishedInSingle = "";
            this.SubjectsSingle = "";
            this.sortBy = "relevancy";
            this.facet === "";
            this.scienceSearch();
        },
        //排序
        facetSortBy(val) {
            this.sortBy = val;
            this.page = 1;
            this.facetPage = 1;
            let url = "";
            let reqUrl = "";
            if (this.facet === "") {
                //正常检索分页
                url = this.$route.query.url;
                url += "&page=" + this.page + "&sortBy=" + this.sortBy;
                reqUrl = "/wiley/search?";
            } else if (this.facet === "facet") {
                //分面检索分页
                url = encodeURIComponent(decodeURIComponent(this.facetUrl) + "&startPage=" + this.facetPage + "&sortBy=" + this.sortBy);
                reqUrl = "/wiley/refine?url=";
            }
            this.$get("https://res.yuntsg.com" + reqUrl + url).then((res) => {
                if (res.code === 0) {
                    this.datalist = res.data.list;
                    this.count = res.data.total;
                    this.PublicationDate = res.data.filters["Publication Date"];
                    this.PublishedIn = res.data.filters["Published in"];
                    this.Subjects = res.data.filters["Subjects"];
                } else {
                    Toast(res.msg);
                }
            });
        },
        //分面检索
        facetSearch(url) {
            this.facet = "facet";
            this.facetUrl = url;
            this.$get("wiley/refine?url=" + encodeURIComponent(url)).then((res) => {
                if (res.code === 0) {
                    this.datalist = res.data.list;
                    this.count = res.data.total;
                    this.PublicationDate = res.data.filters["Publication Date"];
                    this.PublishedIn = res.data.filters["Published in"];
                    this.Subjects = res.data.filters["Subjects"];
                } else {
                    Toast(res.msg);
                }
            });
        },
        //关闭左右侧赛选
        showPopUp: function(type) {
            this.isPopupShow[type] = !this.isPopupShow[type];
        },
        //详情
        getDetail(url) {
            let params = {
                url: url
            };
            this.$router.push({ path: "/wileydetail", query: params });
        }
    }
};
</script>

<style scoped>
.search_list {
    width: 95%;
    margin: 0 auto;
    height: auto;
    display: table;
}

.search_ul {
    display: table;
    width: 100%;
    height: auto;
}

.search_list_single {
    margin-top: 10px;
    padding-bottom: 10px;
    width: 100%;
    height: auto;
    border-bottom: 1px solid #ededed;
}

.search_list_single h2 {
    font-size: 22px;
    color: #555555;
}

.search_list_single p span {
    font-weight: bold;
}

.search_list_single p {
    line-height: 25px;
    margin-top: 5px;
    font-size: 16px;
}

.top {
    height: 45px;
    width: 100%;
}

.top-list {
    border-bottom: 0.005rem solid #e5e5e5; /*no*/
    display: flex;
    width: 100%;
    height: 45px;
}

.group {
    border-right: 0.005rem solid #e5e5e5; /*no*/
}

.top-list li {
    height: 45px;
    font-size: 16px;
    line-height: 45px;
    width: 50%;
    text-align: center;
    color: #2d5459;
}

.count {
    line-height: 35px;
    padding-left: 10px;
}

/*左侧AND右侧弹出菜单样式*/
.md-cell-item-body {
    padding: 0;
    font-size: 16px;
    min-height: 60px;
}

.md-cell-item-body p {
    font-size: 16px;
}

.selectDemo {
    border-bottom: 1px solid #ededed;
}

.selectDemo .md-check-icon i,
.selectDemo .md-radio-icon i {
    font-size: 23px !important;
}

.checkbox_list {
    width: 90%;
    padding-left: 10%;
    height: 30px;
    line-height: 30px;
    display: table;
}

.checkbox_title {
    width: 200px;
    margin-left: 25px;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.tui-checkbox:checked {
    background: #1673ff;
    border: solid 1px #1673ff;
}

.tui-checkbox {
    width: 16px;
    height: 16px;
    float: left;
    background-color: #ffffff;
    border: solid 1px #999999;
    -webkit-border-radius: 20%;
    border-radius: 20%;
    font-size: 16px;
    margin-top: 7px;
    padding: 0;
    position: relative;
    display: inline-block;
    vertical-align: top;
    cursor: default;
    -webkit-appearance: none;
    -webkit-user-select: none;
    user-select: none;
    -webkit-transition: background-color ease 0.6s;
    transition: background-color ease 0.6s;
}

.dan {
    -webkit-border-radius: 50% !important;
    border-radius: 50% !important;
}

.tui-checkbox:checked::after {
    content: "";
    top: 3px;
    left: 3.5px;
    position: absolute;
    background: transparent;
    border: #fff solid 2px;
    border-top: none;
    border-right: none;
    height: 5px;
    width: 5px;
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
}

.md-icon {
    top: -2px !important;
    right: -0.933rem !important;
}

.md-check-label,
.md-radio-label {
    margin-left: 1.64rem !important;
}

.up_down {
    width: 20px;
    height: 20px;
    float: right;
    display: block;
    margin-top: 10px;
}

.dempo_box {
    position: relative;
    height: 100%;
    display: table;
}

.dempo {
    margin-top: 10px;
    width: 95%;
    padding: 15px 2% 45px 2%;
    text-align: left;
}

.left-title {
    line-height: 40px;
    font-size: 24px;
    border-bottom: 0.005rem solid #e5e5e5; /*no*/
}

.select-title {
    width: 100%;
    position: relative;
    cursor: pointer;
    /*height: 40px;*/
    height: auto;
    line-height: 40px;
    font-size: 16px;
    font-weight: bold;
    display: table;
}

.saixuan_tit {
    width: 90%;
    float: left;
}

.md-example-child-popup-0 {
    float: left;
    width: 100%;
}

.md-button {
    margin-bottom: 20px;
}

.md-field {
    padding: 0;
}

.hold {
    font-weight: bold;
}

.md-example-popup {
    position: relative;
    font-size: 16px;
    font-family: DINPro;
    font-weight: 500;
    box-sizing: border-box;
    text-align: center;
    background-color: #fff;
}

.md-example-popup-center {
    padding: 50px;
    /*border-radius :radius-normal;*/
}

.md-example-popup-top {
    width: 100%;
    height: 75px;
    line-height: 75px;
    background: #4a4c5b;
    color: #fff;
}

.md-icon {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
}

.md-icon.icon-font.lg {
    font-size: 1.24rem;
}

.md-example-popup-bottom {
    width: 100%;
    padding: 100px 0;
}

.md-example-popup-bottom p {
    line-height: 50px;
}

.md-example-popup-left,
.md-example-popup-right {
    height: 100%;
    width: 250px;
    display: table;
}

.btn_search_face {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 250px;
    height: auto;
    background-color: white;
}

.btn_search_face_right {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 250px;
    height: auto;

    background-color: white;
}

.btn_search_face button,
.btn_search_face_right button {
    width: 250px;
    float: left;
    height: 40px;
    border: none;
    color: white;
}

.btn_search_face button:nth-child(1),
.btn_search_face_right button:nth-child(1) {
    background-color: #46adcf;
}

.btn_search_face button:nth-child(2),
.btn_search_face_right button:nth-child(2) {
    background-color: #168bc1;
}
</style>
